module.exports = __webpack_public_path__ + "static/image/history/m/202404@3x.png?eec6c563";